
<template>
  <layout :drawer="true" :drawerShow="_isDesktop()" :drawerWidth="300">
    <template slot="drawer">
      <v-form @submit.prevent="loadData">
        <v-row no-gutters class="pt-2 pr-1">

          <v-col cols="12" class="pr-1">
            <smart-multi-select
                v-model="virtualSitesSelected"
                label="Sites"
                :items="virtualSitesItems"
                all-is-same-as-empty
                default-select-all
                @input="loadData"
            />
          </v-col>

          <v-col cols="12" class="mb-2 pt-6">
            <div class="d-flex flex-row align-center justify-space-between">
              <v-subheader light class="pa-0 mb-0 mx-0 form-subheader">
                {{ isIssueMode ? 'Date de création du litige' : 'Dates de séjour' }}
              </v-subheader>
              <v-switch dense hide-details v-model="isIssueMode" @change="loadData" class="ma-0 pa-0"/>
            </div>

            <v-divider/>

          </v-col>
          <template v-if="isIssueMode">
            <v-col class="pr-1" cols="6">
              <smart-picker
                  v-model="searchform.issueStartDate"
                  :stopDate="searchform.issueStopDate"
                  :inputOpts="{
                    label: 'Entre le',
                    clearable: true,
                    placeholder: ' ',
                  }"
              />
            </v-col>
            <v-col class="pr-1" cols="6">
              <smart-picker
                  v-model="searchform.issueStopDate"
                  :stopDate="searchform.issueStartDate"
                  :inputOpts="{
                    label:'et le',
                    clearable: true,
                    placeholder: ' ',
                  }"
              />
            </v-col>
          </template>
          <template v-else>
            <v-col class="pr-1" cols="6">
              <smart-picker
                  v-model="searchform.startDate"
                  :stopDate="searchform.stopDate"
                  :inputOpts="{
                  label: $t('begin'),
                  clearable: true,
                  placeholder: ' ',
                }"
              />
            </v-col>
            <v-col cols="6" class="pr-1">
              <smart-picker
                  v-model="searchform.stopDate"
                  :startDate="searchform.startDate"
                  :inputOpts="{
                  label: $t('end'),
                  clearable: true,
                  placeholder: ' ',
                }"
              />
            </v-col>
          </template>

          <v-col cols="12" class="mt-4">
            <v-subheader light class="pa-0 mt-5 mb-0 mx-0 form-subheader">Statut Litige</v-subheader>
            <v-divider/>
            <smart-btn ghost x-small color="primary" @click.native="selectAllIssueStatus" >
              Tout sélectionner
            </smart-btn>
            <div class="pt-4 pl-2">
              <v-checkbox
                  v-for="(status, index) in prestaIssueStatus"
                  :key="'presta-issue-' + index"
                  v-model="searchform.issueStatus"
                  :label="status.label"
                  :value="status.value"
                  class="mt-0 mb-1"
                  height="1"
                  @change="loadData"
              >
                <template #label>
                  <PrestaIssueStatusChip small :value="status.value"/>
                </template>
              </v-checkbox>
            </div>
          </v-col>

          <v-col cols="12" class="pt-4">
            <v-subheader light class="pa-0 mb-0 mx-0 form-subheader">
              {{'Rechercher par fournisseur'}}
            </v-subheader>
            <v-divider class="mb-4"/>

            <smart-select
                v-model="suppliersSelected"
                :items="suppliersItems"
                :label="supplierSelectLabel"
                all-is-same-as-empty
                default-select-all
                item-text="name"
                item-value="id"
                :chip-style="{ width: '120px' }"
                :loading="loadingSmartSelects"
                clearable
                @input="loadData"
            />
          </v-col>

          <v-col cols="12" class="pt-4">
            <v-subheader light class="pa-0 mb-0 mx-0 form-subheader">
              {{'Rechercher par type de litige'}}
            </v-subheader>
            <v-divider class="mb-4"/>

            <smart-select
                v-model="issueTagSelected"
                :items="issueTagItems"
                :label="issueTagSelectLabel"
                all-is-same-as-empty
                default-select-all
                item-text="name"
                item-value="id"
                :chip-style="{ width: '120px' }"
                :loading="loadingSmartSelects"
                clearable
                @input="loadData"
            />
          </v-col>

          <v-col cols="12" class="pt-4">
            <smart-btn :loading="loading" type="submit" block primary>
              Rechercher
            </smart-btn>
            <smart-btn block tertiary @click.native="clearSearchform()">
              Réinitialiser la recherche
            </smart-btn>
          </v-col>
        </v-row>
      </v-form>
    </template>

    <template slot="content">
      <BookingPrestaIssueListTable ref="issuedBookingList"  @loading="setLoading"/>
    </template>

  </layout>
</template>


<script>
import Layout from "@/views/Layout";
import {startOfMonth} from "date-fns";
import BookingPrestaIssueListTable from "@/components/commons/BookingPrestaIssueListTable.vue";
import PrestaIssueStatusChip from "@/components/commons/PrestaIssueStatusChip.vue";
import {get} from "@/utils/api";
import SmartSelect from "@/components/commons/SmartSelect.vue";
import SmartMultiSelect from "@/components/commons/SmartMultiSelect.vue";


export default {
  name: "IssuedBooking",
  components: {
    SmartMultiSelect, SmartSelect, PrestaIssueStatusChip, BookingPrestaIssueListTable, Layout},
  data() {
    return {
      loading: false,
      isIssueMode: false,
      searchform: this.getDefaultSearchForm(),
      loadingSmartSelects: false,
      suppliersItems: [],
      suppliersSelected: [],
      issueTagItems: [],
      issueTagSelected: [],
      virtualSitesItems: [],
      virtualSitesSelected: []
    }
  },
  created() {
    this.loadingSmartSelects = true
    Promise.all([
      this.fetchSupplierAccounts(),
      this.fetchIssueTags(),
      this.fetchVirtualSites()
    ]).then(() => {
      this.loadingSmartSelects = false
      this.loadData()
    })
  },
  computed: {
    prestaIssueStatus() {
      return [
          { value: "in_progress", label: "En cours" },
          { value: "give_up", label: "Sans suite" },
          { value: "closed", label: "Clos" },
        ]
    },
    supplierSelectLabel() {
      return Array.isArray(this.suppliersSelected) && this.suppliersSelected.length > 0
          ? 'Fournisseur'
          : 'Tous les fournisseurs'
    },
    issueTagSelectLabel() {
      return Array.isArray(this.issueTagSelected) && this.issueTagSelected.length > 0
          ? 'Type de litige'
          : 'Tous types de litige'
    }
  },
  methods: {
    getDefaultSearchForm() {
      return {
        startDate: this._formatDate(startOfMonth(new Date()), "dd/MM/yyyy"),
        stopDate: this._nowFormatted("dd/MM/yyyy"),
        issueStartDate: this._formatDate(startOfMonth(new Date()), "dd/MM/yyyy"),
        issueStopDate: this._nowFormatted("dd/MM/yyyy"),
        issueStatus: ['in_progress'],
      }
    },
    setLoading(loading) {
      this.loading = loading;
    },
    clearSearchform() {
      this.searchform = {...this.getDefaultSearchForm()}
      this.suppliersSelected = []
      this.issueTagSelected = []
      this.selectedVirtualSites = []
    },
    selectAllIssueStatus() {
      this.searchform.issueStatus = this.prestaIssueStatus.map((status) => status.value)
      this.loadData()
    },
    fetchIssueTags() {
      const url = `/api/prestation/prestation-issue/tags`;

      return get(url)
          .json((r) => {
            this.issueTagItems = r.map((tag) => { return {name: tag.tag, id: tag.id} })
          })
    },
    fetchSupplierAccounts() {
      const url = `/api/supplier/get/foraccounting`;

      return get(url)
          .json((r) => {
            this.suppliersItems = r.map((account) => { return {name: account.name, id: account.id} })
          })
    },
    fetchVirtualSites() {
      const url = `/api/search/virtual-sites`;

      return get(url)
          .json((sites) => {
            this.virtualSitesItems = sites.map((site) => { return {name: site.name, id: site.id} })
          })
    },
    loadData() {
      this.$nextTick(() => {
        const supplierId = Array.isArray(this.suppliersSelected) && this.suppliersSelected.length > 0 ? this.suppliersSelected[0] : null
        const issueTagId = Array.isArray(this.issueTagSelected) && this.issueTagSelected.length > 0 ? this.issueTagSelected[0] : null
        const sites = Array.isArray(this.virtualSitesSelected) ? this.virtualSitesSelected : []

        const form = this.isIssueMode ?
            {
              issueStartDate: this.searchform.issueStartDate,
              issueStopDate: this.searchform.issueStopDate,
            } : {
              startDate: this.searchform.startDate,
              stopDate: this.searchform.stopDate,
            }

        const finalForm = {
          ...form,
          issueStatus: this.searchform.issueStatus,
          supplierAccountingId: supplierId,
          issueTagId: issueTagId,
          virtualSites: sites,
        }

        this.$refs.issuedBookingList.load("/api/widget/bookings/issues", finalForm);
      })
    },
  } // [N] end methods

}
</script>


<style scoped>

</style>